import { Routes } from "@angular/router";
import { LoginComponent } from "./auth/login/login.component";
import { PageComponent } from "./cmspage/page/page.component";
import { ContactFormComponent } from "./cmspage/contact-form/contact-form.component";
import { PageNotFoundComponent } from "./page-not-found/page-not-found.component";
import { AuthGuard } from "./auth/auth.guard";

import { AdminComponent } from "./layout/admin.component";
import { AdminDashboardComponent } from "./admin-dashboard/admin-dashboard.component";
import { ManageCategoriesComponent } from "./settings/category/manage-categories/manage-categories.component";

import { CategoryFormComponent } from "./settings/category/category-form/category-form.component";
import { ManageClientsComponent } from "./clients/manage-clients/manage-clients.component";
import { ClientsFormComponent } from "./clients/clients-form/clients-form.component";
import { ManageBookingsComponent } from "./bookings/manage-bookings/manage-bookings.component";
import { BookingsFormComponent } from "./bookings/bookings-form/bookings-form.component";
import { ManageBillingsComponent } from "./billings/manage-billings/manage-billings.component";
import { BillingsFormComponent } from "./billings/billings-form/billings-form.component";
import { WorksFormComponent } from "./settings/works/works-form/works-form.component";
import { ManageWorksComponent } from "./settings/works/manage-works/manage-works.component";
import { SettingsComponent } from "./settings/settings.component";
import { LocationsFormComponent } from "./settings/locations/locations-form/locations-form.component";
import { ManageLocationsComponent } from "./settings/locations/manage-locations/manage-locations.component";
import { ManageTypeComponent } from "./settings/type/manage-type/manage-type.component";
import { TypeFormComponent } from "./settings/type/type-form/type-form.component";
import { CompanyFormComponent } from "./settings/company/company-form/company-form.component";
import { ManageRoomsComponent } from "./rooms/manage-rooms/manage-rooms.component";
import { RoomsFormComponent } from "./rooms/rooms-form/rooms-form.component";
import { ManageBookingTypeComponent } from "./settings/booking-type/manage-booking-type/manage-booking-type.component";
import { BookingTypeFormComponent } from "./settings/booking-type/booking-type-form/booking-type-form.component";
import { ManageSupportsComponent } from "./supports/manage-supports/manage-supports.component";
import { SupportsFormComponent } from "./supports/supports-form/supports-form.component";
import { ManageTechnicalDataComponent } from "./settings/technical-data/manage-technical-data/manage-technical-data.component";
import { TechnicalDataFormComponent } from "./settings/technical-data/technical-data-form/technical-data-form.component";
import { QuotesFormComponent } from "./quotes/quotes-form/quotes-form.component";
import { ManageQuotesComponent } from "./quotes/manage-quotes/manage-quotes.component";
import { ManagePersonalDataComponent } from "./settings/personal-data/manage-personal-data/manage-personal-data.component";
import { PersonalDataFormComponent } from "./settings/personal-data/personal-data-form/personal-data-form.component";

import { TasksComponent } from "./tasks/tasks.component";
import { ManageTimesheetsComponent } from "./timesheets/manage-timeheets/manage-timesheets.component";
import { TimesheetsFormComponent } from "./timesheets/timesheets-form/timesheets-form.component";

import { BookingsCalendarComponent } from "./bookings/bookings-calendar/bookings-calendar.component";
import { ManageDocumentsComponent } from "./documents/manage-documents/manage-documents.component";
import { DocumentsFormComponent } from "./documents/documents-form/documents-form.component";
import { ManageEmployeesComponent } from "./employees/manage-employees/manage-employees.component";
import { EmployeesFormComponent } from "./employees/employees-form/employees-form.component";
import { EmployeesTimesheetsComponent } from "./employees/employees-timeheets/employees-timesheets.component";
import { ManageComuniComponent } from "./settings/comuni/manage-comuni/manage-comuni.component";
import { ManageRequestsComponent } from "./requests/manage-requests/manage-requests.component";
import { RequestsFormComponent } from "./requests/requests-form/requests-form.component";
import { ManagePagesComponent } from "./pages/manage-pages/manage-pages.component";
import { PagesFormComponent } from "./pages/pages-form/pages-form.component";
import { WebsiteSettingsComponent } from "./settings/website/website-settings.component";
import { PaymentsSettingsComponent } from "./settings/payments/payments-settings.component";
import { ManageCompanyComponent } from "./settings/company/manage-company/manage-company.component";

export const routes: Routes = [
  { path: "page/:slug", component: PageComponent },
  { path: "contact", component: ContactFormComponent },
  {
    path: "admin",
    component: AdminComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        children: [
          { path: "dashboard", component: AdminDashboardComponent },

          { path: "support", component: ManageSupportsComponent },
          { path: "support/create", component: SupportsFormComponent },
          { path: "support/:id", component: SupportsFormComponent },

          { path: "rooms", component: ManageRoomsComponent },
          { path: "rooms/create", component: RoomsFormComponent },
          { path: "rooms/edit/:id", component: RoomsFormComponent },

          { path: "timesheets", component: ManageTimesheetsComponent },
          { path: "timesheets/create", component: TimesheetsFormComponent },
          { path: "timesheets/edit/:id", component: TimesheetsFormComponent },

          { path: "bookings", component: ManageBookingsComponent },
          { path: "bookings/create", component: BookingsFormComponent },
          {
            path: "bookings/edit/:id",
            component: BookingsFormComponent,
          },
          { path: "calendar", component: BookingsCalendarComponent },

          { path: "documents", component: ManageDocumentsComponent },
          { path: "documents/create", component: DocumentsFormComponent },
          { path: "documents/edit/:id", component: DocumentsFormComponent },

          { path: "billings", component: ManageBillingsComponent },
          { path: "billings/edit/:id", component: BillingsFormComponent },
          { path: "billings/create", component: BillingsFormComponent },

          { path: "quotes", component: ManageQuotesComponent },
          { path: "quotes/edit/:id", component: QuotesFormComponent },
          { path: "quotes/create", component: QuotesFormComponent },

          { path: "employees", component: ManageEmployeesComponent },
          { path: "employees/edit/:id", component: EmployeesFormComponent },
          { path: "employees/create", component: EmployeesFormComponent },
          {
            path: "employee/timesheets/:id",
            component: EmployeesTimesheetsComponent,
          },

          { path: "clients", component: ManageClientsComponent },
          { path: "clients/create", component: ClientsFormComponent },
          { path: "clients/edit/:id", component: ClientsFormComponent },

          { path: "requests", component: ManageRequestsComponent },
          { path: "requests/create", component: RequestsFormComponent },
          { path: "requests/edit/:id", component: RequestsFormComponent },

          { path: "settings", component: SettingsComponent },

          { path: "settings/categories", component: ManageCategoriesComponent },
          {
            path: "settings/categories/edit/:id",
            component: CategoryFormComponent,
          },
          {
            path: "settings/categories/create",
            component: CategoryFormComponent,
          },

          { path: "settings/type", component: ManageTypeComponent },
          { path: "settings/type/edit/:id", component: TypeFormComponent },
          { path: "settings/type/create", component: TypeFormComponent },

          { path: "settings/works", component: ManageWorksComponent },
          { path: "settings/works/edit/:id", component: WorksFormComponent },
          { path: "settings/works/create", component: WorksFormComponent },

          { path: "settings/comuni", component: ManageComuniComponent },
          {
            path: "settings/comuni/edit/:id",
            component: LocationsFormComponent,
          },

          { path: "settings/locations", component: ManageLocationsComponent },
          {
            path: "settings/locations/edit/:id",
            component: LocationsFormComponent,
          },
          {
            path: "settings/locations/create",
            component: LocationsFormComponent,
          },

          {
            path: "settings/technical-data",
            component: ManageTechnicalDataComponent,
          },
          {
            path: "settings/technical-data/edit/:id",
            component: TechnicalDataFormComponent,
          },
          {
            path: "settings/technical-data/create",
            component: TechnicalDataFormComponent,
          },

          {
            path: "settings/personal-data",
            component: ManagePersonalDataComponent,
          },
          {
            path: "settings/personal-data/edit/:id",
            component: PersonalDataFormComponent,
          },
          {
            path: "settings/personal-data/create",
            component: PersonalDataFormComponent,
          },

          {
            path: "settings/booking-type",
            component: ManageBookingTypeComponent,
          },
          {
            path: "settings/booking-type/edit/:id",
            component: BookingTypeFormComponent,
          },
          {
            path: "settings/booking-type/create",
            component: BookingTypeFormComponent,
          },

          { path: "settings/website", component: WebsiteSettingsComponent },
          { path: "settings/payments", component: PaymentsSettingsComponent },
          { path: "settings/company", component: ManageCompanyComponent },
          {
            path: "settings/company/create",
            component: CompanyFormComponent,
          },
          {
            path: "settings/company/edit/:id",
            component: CompanyFormComponent,
          },

          { path: "pages", component: ManagePagesComponent },
          { path: "pages/create", component: PagesFormComponent },
          { path: "pages/edit/:id", component: PagesFormComponent },

          { path: "", component: AdminDashboardComponent },

          { path: "tasks", component: TasksComponent },
          { path: "projects/task/:project_id", component: TasksComponent },
        ],
      },
    ],
  },
  { path: "login", component: LoginComponent },
  { path: "", redirectTo: "admin/dashboard", pathMatch: "full" },
  { path: "**", component: PageNotFoundComponent },
];
